import { render, staticRenderFns } from "./TabelaBacklogTarefaExecucaoComponent.vue?vue&type=template&id=7729699e"
import script from "./TabelaBacklogTarefaExecucaoComponent.vue?vue&type=script&lang=js"
export * from "./TabelaBacklogTarefaExecucaoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports